// extracted by mini-css-extract-plugin
export default {"container":"Qg2dOk6ADCzjWyLvLyfs","mainContent":"WBaxys9fndGAlpGLQ9JW","tab":"UuYpxG30kxMc9dedUbM6","tab--active":"dp21ROHs0e0DM8ZXbvyx","bounce":"obX8TBaSkKMvB2iQL2Tc"};